const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    intake_no: "",
    material_id: "",
    customer_id: null,
    issue_descriptions: "",
    received_date: "",
    received_by: "",
    status: "Pending",
    material_serial_no: "",
    is_repairable: null,
    technician_id: "",
    items_matching_invoice: null,
    comments: "",
    anti_static_bag: null,
    fault_tag_attached: null,
    fault_reported_from_field: "",
    branch_id: null,
    zone_id: null,
    rate_per_unit: "",

    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "material_intakes",
    schema: schema,
    include: [
      {
        model: "material_masters",
        as: "material",
      },
      {
        model: "branch_masters",
        as: "branch",
      },
      {
        model: "zone_masters",
        as: "zone",
      },
      {
        model: "user_masters",
        as: "received_by_user",
      },
      {
        model: "user_masters",
        as: "inspected_by_user",
      },
      {
        model: "job_cards",
        as: "job_cards",
        required: false,
        include: [
          {
            model: "user_masters",
            as: "technician",
          },
        ],
      },
    ],
  };

  const navigatePage = { back: "/item-intakes-list" };

  const headerName = "Item Intakes";

  const validationType = "MaterialIntakesCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "material_intakes",
    schema: schema,
    include: [
      {
        model: "material_masters",
        as: "material",
      },
      {
        model: "branch_masters",
        as: "branch",
      },
      {
        model: "zone_masters",
        as: "zone",
      },
      {
        model: "client_masters",
        as: "customer",
      },
      {
        model: "user_masters",
        as: "received_by_user",
      },
      {
        model: "user_masters",
        as: "inspected_by_user",
      },
      {
        model: "job_cards",
        as: "job_cards",
        required: false,
        include: [
          {
            model: "user_masters",
            as: "technician",
          },
        ],
      },
    ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Item Name", value: "material.name" },
    { label: "Serial Number", value: "material_serial_no" },
    { label: "Intake Number", value: "intake_no" },
    { label: "Is Repairable", value: "is_repairable" },
    { label: "Technician", value: "job_cards[0].technician.full_name" },
    { label: "Items Matching Invoice", value: "items_matching_invoice" },
    { label: "Anti Static Bag", value: "anti_static_bag" },
    { label: "Fault Tag Attached", value: "fault_tag_attached" },
    { label: "Fault Reported From Field", value: "fault_reported_from_field" },
    { label: "Branch Name", value: "branch.branch_name" },
    { label: "Zone Name", value: "zone.zone_name" },
    { label: "Rate Per Unit", value: "rate_per_unit" },
    { label: "Received By", value: "received_by_full_name" },
    { label: "Received Date", value: "received_date" },
    { label: "Status", value: "status" },
    { label: "Is Active", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/item-intakes-create",
    edit: "/item-intakes-create",
    view: "/item-intakes-view",
  };

  const searchfields = [
    "intake_no",
    "material.name",
    "customer.client_name",
    "inspected_by_user.first_name",
    "inspected_by_user.last_name",
    "received_by_user.first_name",
    "received_by_user.last_name",
    "status",
    // "job_cards[0].technician.first_name",
    // "job_cards[0].technician.last_name",
  ];

  const headerName = "Item Intakes";
  const endpoint = "/getRecords";
  const exportFileName = "MaterialIntakesData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "material_intakes",
  schema: schema,
  include: [
    { model: "material_masters", as: "material" },
    { model: "client_masters", as: "customer" },
    { model: "user_masters", as: "received_by_user" },
    { model: "user_masters", as: "inspected_by_user" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
